import React, { useState } from "react";
import Popup from "../../../../../assets/customSVG/accounts/Popup";
import { images } from "../../../../../assets/images/index";
import { headingColor } from "../../../constants";

const ModelContent = ({
  showSidebar,
  sideNavLabel,
  ModelSideNav,
  headerLabel,
  Toggle,
  children,
  rootClassName = "",
  mainClassName = "",
  sideBarMainClassName = "",
  Footer = "",
  showBack = false,
  backAction = () => {},
  ...rest
}) => {
  const [closeHover, setCloseHover] = useState(false);

  return (
    <div className={`h-full flex ${rootClassName}`}>
      {showSidebar && (
        <>
          <div
            className={`bg-[#F4F6F8] p-[1vw] border-r border-r-slate-200 space-y-[2.2vh] min-w-[195px] max-w-[195px] ${sideBarMainClassName}`}
          >
            {sideNavLabel && (
              <h2
                className={`font-bold text-[${headingColor}] capitalize text-[2vh] mb-[2vw]`}
              >
                {sideNavLabel}
              </h2>
            )}

            <>{ModelSideNav}</>
          </div>
        </>
      )}
      <div className={`overflow-scroll flex-1 min-w-[600px] ${mainClassName}`}>
        {headerLabel && (
          <>
            <div id="modelMain" className="sticky top-0 px-[1vw] pt-[.5vw]">
              <div className="flex items-center border-b border-b-gray-100 justify-between bg-white pb-4-h-[10vh]">
                <p className="flex min-h-[6vh]  *:duration-200 items-center relative ">
                  <span
                    onClick={backAction}
                    className={`absolute cursor-pointer opacity-0  ${
                      showBack ? "scale-[1_important] opacity-100" : "scale-0"
                    }  text-[1.5vw] h-full flex items-center border-e border-e-gray-100 pe-4 me-4`}
                  >
                    <img
                      className="w-[2vw] ms-[1vw]"
                      src={images?.CampaignBackIcon}
                      alt=""
                    />
                  </span>
                  <span
                    className={`${
                      showBack ? "ps-[5vw]" : "ps-[0]"
                    } flex items-center font-[600] text-[.95vw] h-[2vw]`}
                  >
                    {headerLabel}
                  </span>
                </p>
                <div
                  onClick={Toggle}
                  onMouseOver={() => setCloseHover(true)}
                  onMouseOut={() => setCloseHover(false)}
                  className="pointer"
                >
                  <Popup
                    color={!closeHover ? "var(--textBlack)" : "#FF543E"}
                    fill={!closeHover ? "#F1F4F6" : "#FFE3E0"}
                  />
                </div>
              </div>
              {/* <Underline weight="thin" /> */}
            </div>
          </>
        )}
        <>{children}</>
        {Footer && <div className="sticky">{Footer}</div>}
      </div>
    </div>
  );
};

export default ModelContent;
